module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-entry-5b74afefb42c5e3fdf8bb684d9516251.svg";